var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{attrs:{"id":"pages-menu"}},_vm._l((_vm.pages),function(item,index){return _c('li',{key:index,staticClass:"pages-list"},[_c('router-link',{staticClass:"page-link",attrs:{"active-class":"active","to":{name: item.name}}},[_vm._v(" "+_vm._s(item.name)+" "),_c('div',{staticClass:"page-bar"})])],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }